import styles from './SupportedPayments.module.scss';
import { IApplicationState } from '@spinwise/spinwise-core';
import { useSelector } from 'react-redux';
import { useRef } from 'react';
import { EBaseButtonSize, EBaseButtonType } from '@spinwise/react-component-library/ButtonAbstract';
import { IconVariantsLibrary } from 'Libraries/variants.library';
import { IconLibrary } from 'Libraries/icons.library';
import classNames from 'classnames';
import useHorizontalScroll from 'Hooks/useHorizontalScroll';
import { ROW_PAYMENTS } from './RowPayments';
import { HITZ_COUNTRIES } from 'Types/globals';
import { ButtonIconOnly } from '@spinwise/react-component-library/ButtonIconOnly';

const NAVIGATION_SCROLL_OFFSET = 150;

interface ISupportedPayments {
  payment_methods: any;
  buttonColor: string;
}

const SupportedPayments = ({ payment_methods = {}, buttonColor }: ISupportedPayments) => {
  const { geo } = useSelector((state: IApplicationState) => state.globalReducer);
  let paymentMethods = ROW_PAYMENTS(geo?.code2);

  if (payment_methods && HITZ_COUNTRIES?.includes(geo?.code2)) {
    paymentMethods = [];
    Object.keys(payment_methods).forEach(function (prop) {
      paymentMethods.push(payment_methods[prop]);
    });
  }

  const navRef = useRef<HTMLDivElement>();
  const { scrollTo } = useHorizontalScroll(0, navRef);

  return (
    <>
      <div className={`${styles.payment_support_container} d-fl ai-c`} ref={navRef}>
        <div className={`${styles.payment_support_block} d-fl ai-c jc-c`}>
          {paymentMethods
            ?.filter(payment => payment?.country_code?.includes(geo?.code2))
            .map(filteredPayment => (
              <div key={filteredPayment?.id} className={styles.payment_support_block__item}>
                <img src={filteredPayment?.image?.data?.attributes?.url} alt="" />
              </div>
            ))}
        </div>
        <div
          className={classNames(styles.nav_arrow, styles.nav_arrow__left)}
          style={{ background: buttonColor }}
          onClick={() =>
            scrollTo({
              side: 'left',
              offset: NAVIGATION_SCROLL_OFFSET,
            })
          }
        >
          <ButtonIconOnly
            size={EBaseButtonSize.Small}
            type={EBaseButtonType.None}
            isStatic={true}
            variant={IconVariantsLibrary.White}
            isMasked={true}
            iconName={IconLibrary.ArrowRight}
            ariaLabel="scroll left"
          />
        </div>
        <div
          className={styles.nav_arrow}
          style={{ background: buttonColor }}
          onClick={() =>
            scrollTo({
              side: 'right',
              offset: NAVIGATION_SCROLL_OFFSET,
            })
          }
        >
          <ButtonIconOnly
            size={EBaseButtonSize.Small}
            type={EBaseButtonType.None}
            isStatic={true}
            variant={IconVariantsLibrary.White}
            isMasked={true}
            iconName={IconLibrary.ArrowRight}
            ariaLabel="scroll right"
          />
        </div>
      </div>
    </>
  );
};

export default SupportedPayments;
